// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2BIG8","bigColWidth":"Table_bigColWidth__2e-95","biggerColWidth":"Table_biggerColWidth__2iUJ3","row":"Table_row__2bqeZ","col":"Table_col__QBRcj"};